import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { Auth } from '../services/auth';

/**
 * Décide de ce que voit un visiteur à la racine du site.
 *
 * La vitrine s'adresse à quelqu'un qui découvre l'application depuis le web et
 * n'a pas de compte. Elle n'a donc aucun sens dans l'application installée, où
 * la racine doit ouvrir l'accueil, ni pour une personne déjà connectée — à qui
 * l'on présenterait une page de téléchargement de l'application qu'elle utilise.
 */
export const landingGuard: CanActivateFn = async () => {
  const router = inject(Router);

  if (Capacitor.isNativePlatform()) {
    return router.createUrlTree(['/home']);
  }

  const auth = inject(Auth);
  await auth.authReady;
  return auth.currentUser() ? router.createUrlTree(['/home']) : true;
};
